var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React from "react";
import { Box, Image } from "grommet";
import FTM from "../../Icons/MainLogo/logo_ftm.svg";
import styled from "styled-components";
var LinkWrapper = styled.a(
  _templateObject || (_templateObject = _taggedTemplateLiteralLoose([""]))
);
export var MainLogo = function MainLogo(_ref) {
  var as = _ref.as;
  return /*#__PURE__*/ React.createElement(
    Box,
    {
      flex: true,
    },
    /*#__PURE__*/ React.createElement(
      LinkWrapper,
      {
        as: as,
        to: "/",
      },
      /*#__PURE__*/ React.createElement(Image, {
        src: FTM,
        height: "40px",
        alt: "\u041B\u043E\u0433\u043E\u0442\u0438\u043F \u0424\u0422\u041C",
        alignSelf: "center",
      })
    )
  );
};
